import axios from 'axios'
import { hostUI } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const initialState = {
    records: [],
    pagination: {
        totalRecords: 0,
        totalPages: 1,
        currentPage: 1,
        limit: 10
    },
    loading: false,
    error: null
}

const OBTENER_NO_TERMINADO_LISTA = 'bitacoraEnvasadoNoTerminado/obtenerLista'
const GUARDAR_NO_TERMINADO_RECORD = 'bitacoraEnvasadoNoTerminado/guardarRecord'
const ACTUALIZAR_NO_TERMINADO_RECORD = 'bitacoraEnvasadoNoTerminado/actualizarRecord'

export const obtenerNoTerminadoRecords = createAsyncThunk(
    OBTENER_NO_TERMINADO_LISTA,
    async (params, { rejectWithValue }) => {
        try {
            let idLogin = null;
            let page = 1;
            let limit = 20;
            let search = '';

            if (typeof params === 'object' && params !== null) {
                idLogin = params.idLogin || params.id_login || null;
                page = params.page || 1;
                limit = params.limit || 20;
                search = params.search || '';
            } else {
                idLogin = params;
            }

            const queryParts = [];
            if (idLogin) queryParts.push(`id_login=${idLogin}`);
            if (page) queryParts.push(`page=${page}`);
            if (limit) queryParts.push(`limit=${limit}`);
            if (search) queryParts.push(`search=${encodeURIComponent(search)}`);

            const queryString = queryParts.length ? `?${queryParts.join('&')}` : '';
            const url = `${hostUI}bitacora-envasado/no-terminado${queryString}`;

            const res = await axios.get(url);
            return {
                records: res.data.data || [],
                pagination: res.data.pagination || { totalRecords: (res.data.data || []).length, totalPages: 1, currentPage: 1, limit: 20 }
            };
        } catch (error) {
            console.error("Error al obtener registros de envasado no terminado:", error);
            return rejectWithValue(error.response?.data || error.message);
        }
    }
)

export const guardarNoTerminadoRecord = createAsyncThunk(
    GUARDAR_NO_TERMINADO_RECORD,
    async (recordData, { rejectWithValue }) => {
        try {
            const url = `${hostUI}bitacora-envasado/no-terminado`;
            const res = await axios.post(url, recordData);
            return res.data.data;
        } catch (error) {
            console.error("Error al guardar envasado no terminado:", error);
            return rejectWithValue(error.response?.data || error.message);
        }
    }
)

export const actualizarNoTerminadoRecord = createAsyncThunk(
    ACTUALIZAR_NO_TERMINADO_RECORD,
    async ({ id, recordData }, { rejectWithValue }) => {
        try {
            const url = `${hostUI}bitacora-envasado/no-terminado/${id}`;
            const res = await axios.put(url, recordData);
            return res.data.data;
        } catch (error) {
            console.error("Error al actualizar envasado no terminado:", error);
            return rejectWithValue(error.response?.data || error.message);
        }
    }
)

const bitacoraEnvasadoNoTerminadoSlice = createSlice({
    name: 'bitacoraEnvasadoNoTerminado',
    initialState,
    reducers: {
        resetNoTerminadoError: (state) => {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(obtenerNoTerminadoRecords.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(obtenerNoTerminadoRecords.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.records = payload.records;
                state.pagination = payload.pagination;
            })
            .addCase(obtenerNoTerminadoRecords.rejected, (state, { payload }) => {
                state.loading = false;
                state.error = payload;
            })
            .addCase(guardarNoTerminadoRecord.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.records.unshift(payload);
            })
            .addCase(actualizarNoTerminadoRecord.fulfilled, (state, { payload }) => {
                state.loading = false;
                const idx = state.records.findIndex(r => (r.id_bitacora_envasado_no_terminado || r.id) === (payload.id_bitacora_envasado_no_terminado || payload.id));
                if (idx !== -1) state.records[idx] = { ...state.records[idx], ...payload };
            });
    }
});

export const { resetNoTerminadoError } = bitacoraEnvasadoNoTerminadoSlice.actions;
export default bitacoraEnvasadoNoTerminadoSlice.reducer;
